import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { SubscriptionPlanData } from '../../../@core/interfaces/common/CalorieFriend/subscriptionPlan';

@Component({
  selector: 'ngx-subscriptions-table',
  templateUrl: './subscriptions-table.component.html',
  styleUrls: ['./subscription-table.component.scss'],
})
export class SubscriptionsTableComponent {
  settings = {
    mode: 'external',
    actions: {
      add: false,
      delete: false,
    },
    edit: {
      editButtonContent:
        '<img src="assets/icons/added_oultine_modify_pencil.svg" class="img-archive" width="24" height="24">',
    },
    columns: {
      planName: {
        title: 'Plan Name',
        type: 'string',
      },
      planCode: {
        title: 'Plan Code',
        type: 'string',
      },
      priceId: {
        title: 'Price Id',
        type: 'string',
      },
      patientsCount: {
        title: 'Clients Count',
        type: 'string',
      },
      price: {
        title: 'Price',
        type: 'string',
      },
      isFreePlan: {
        title: 'Free Plan',
        type: 'checkbox',
      },
      hasAssessments: {
        title: 'Has Assessments',
        type: 'checkbox',
      },
      hasBranding: {
        title: 'Has Branding',
        type: 'checkbox',
      },
      hasPlanChoices: {
        title: 'Has Plan Choices',
        type: 'checkbox',
      },
    },
  };

  source: DataSource;

  constructor(
    private subscriptionsService: SubscriptionPlanData,
    private router: Router,
  ) {
    this.source = this.subscriptionsService.gridDataSource;
  }

  addSubscriptionPlan() {
    this.router.navigate(['/admin/subscriptions/add/']);
  }

  onEdit($event: any) {
    this.router.navigate([`/admin/subscriptions/edit/${$event.data.id}`]);
  }
}
